import { useState, useEffect } from 'react'
import { flightModeStyle } from './style'

export const DurationControl = ({ onChange, value, log }) => {
  const [minutes, setMinutes] = useState(value ?? 60)
  const [duration, setDuration] = useState()
  const [number, setNumber] = useState()

  const durations = {
    days: 60 * 24,
    hours: 60,
    minutes: 1,
  }

  const selectedDuration = () => {
    let result = null
    for(const [name, value] of Object.entries(durations)) {
      if(minutes >= value) {
        if(!result || durations[result] < value) {
          result = name
        }
      }
    }
    if(log)
      console.log('selectDuration.return', result)
    
    return result
  }

  const valueForDuration = () => {
    const duration = selectedDuration(minutes)
    const factor = durations[duration]
    
    if(log)
      console.log('valueForDuration', minutes, duration, factor)

    return minutes / durations[duration]
  }

  useEffect(() => {
    if(duration && number) {
      const factor = durations[duration]
      const newMinutes = number * factor
      setMinutes(newMinutes)
    }
  }, [duration, number])

  useEffect(() => {
    if(onChange)
      onChange(minutes)
  },[minutes])

  if(!duration)
    setDuration(selectedDuration())

  if(!number)
    setNumber(valueForDuration())

  return (
    <div>
      <input style={{ ...flightModeStyle.input, width: '50px' }} type="number" value={number} onChange={e => setNumber(parseInt(e.target.value ?? 0))} />
      <select style={flightModeStyle.input} value={duration} onChange={e => setDuration(e.target.value)}>
        {Object.getOwnPropertyNames(durations).map((n, idx) => (<option key={idx}>{n}</option>))}
      </select>
    </div>
  )
}

